/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Mobx model related to print offer for authhome
 *
 * @file printOffer.js
 * @author Mohamed yasar arabath M
 */

import { types } from 'mobx-state-tree';

/**
 * A mobx model for print offer details
 */
const PrintOffer = types.model('PrintOffer', {
  title: types.maybeNull(types.string),
  offerId: types.maybeNull(types.string),
  productId: types.maybeNull(types.string),
  relatedProductId: types.maybeNull(types.string)
});

export default PrintOffer;
